import { render, staticRenderFns } from "./check-bill.vue?vue&type=template&id=567dcb07&scoped=true&"
import script from "./check-bill.vue?vue&type=script&lang=js&"
export * from "./check-bill.vue?vue&type=script&lang=js&"
import style0 from "./check-bill.vue?vue&type=style&index=0&id=567dcb07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567dcb07",
  null
  
)

export default component.exports